import "core-js/modules/es.number.max-safe-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import React from 'react'; // Function to generate unique id numbers.

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var counter = 1;

function resetUID() {
  counter = 1;
}

function generateUID(prefix) {
  counter = (counter + 1) % Number.MAX_SAFE_INTEGER; // Prevent crazy overflows by wrapping.

  if (prefix) {
    return "".concat(prefix, "-").concat(counter);
  }

  return "".concat(counter);
}

function nodeIsChildOf(node, parent) {
  var nodeParent = node.parentNode;

  if (!nodeParent) {
    return false;
  }

  if (nodeParent.isSameNode(parent)) {
    return true;
  }

  return nodeIsChildOf(nodeParent, parent);
}

function formatCustomAttribute(text) {
  return text.replace(' ', '_').toLowerCase().trim();
} // Makes a cancelable promise so that they can be cancelled on unmount.


function makeCancelable(promise) {
  /* eslint-disable prefer-promise-reject-errors */
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled = true;
    }
  };
}
/**
 * Replace the tokens in a string of text
 * @param {string} text   The text to replace tokens in.
 * @param {object} tokens An object with keys of the tokens to replace
 *                        and values of the replacements.
 * @param {boolean} join  Whether or not to join the parts back together as a string.
 * @param {RegExp} format Regex to look for tokens. Default is starting with !, @, %, Or token as [token].
 */


function replaceTokens(text, tokens) {
  var join = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /([%@!]\w+|\[[\w:]+\])/g;

  if (!text) {
    return '';
  }

  var textParts = text.split(format);
  var replacedTextParts = textParts.map(function (value) {
    return value in tokens ? tokens[value] : value;
  }); // If we should join the parts back together as strings.

  if (join) {
    return replacedTextParts.join('');
  }

  return replacedTextParts;
}
/**
 * From Applanga JS - parse strings with tokens.
 * @param {string} text                 The text to replace tokens in.
 * @param {object} interpolationParams  An object with keys of the tokens to replace
 *                                      and values of the replacements.
 */


function parseInterpolationParams(text, interpolationParams) {
  if (!text) {
    return '';
  }

  Object.keys(interpolationParams).forEach(function (param) {
    var variableTemplate = "{{".concat(param, "}}");
    text = text.replace(new RegExp(variableTemplate, 'g'), interpolationParams[param]);
  });
  return text;
}
/**
 * Check if link title and text match. Return undefined if they match.
 * @param {string} text  Link text.
 * @param {string} title Link title.
 */


function getLinkTitleText(text, title) {
  if (!title) {
    return undefined;
  }

  return title.toLowerCase() !== text.toLowerCase() ? title : undefined;
}
/**
 * Returns children as html element.
 * @param {node} children Children node.
 * @param {string} Element String of html element to wrap item with.
 * @param {boolean} noWrap rule to determine whether to wrap text children in fragment instead of Element
 */


var dangerousHTML = function dangerousHTML(children) {
  var Element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  var noWrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return React.Children.map(children, function (item) {
    if ( /*#__PURE__*/React.isValidElement(item)) {
      return item;
    } else if (noWrap && item && typeof item === 'string') {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: item
      });
    } else if (typeof item === 'string' || typeof item === 'number') {
      return /*#__PURE__*/_jsx(Element, {
        dangerouslySetInnerHTML: {
          __html: item + ''
        }
      });
    } else {
      return null;
    }
  });
};
/**
 * Format a distance string with the unit of measure
 *
 * @param {number} distanceInMiles distance in miles
 * @param {string} unit formatted unit: km (default) or miles
 *
 * @return {string}
 */


function distance(distanceInMiles) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'km';
  var units = {
    miles: {
      conversionFactor: 1,
      label: 'mi.'
    },
    km: {
      conversionFactor: 1.60934,
      label: 'km'
    }
  }; // Fall back to km if the unit specified is not found.

  var unitInfo = unit in units ? units[unit] : units.km;
  var distanceInUnit = (distanceInMiles * unitInfo.conversionFactor).toFixed(2);
  return "".concat(distanceInUnit, " ").concat(unitInfo.label);
}

var getDurationFromMs = function getDurationFromMs(milliseconds) {
  var sec = Math.floor(milliseconds / 1000);
  var hrs = Math.floor(sec / 3600);
  sec -= hrs * 3600;
  var min = Math.floor(sec / 60);
  sec -= min * 60;
  var secStr = '' + sec;
  secStr = ('00' + secStr).substring(secStr.length);

  if (hrs > 0) {
    var minStr = '' + min;
    minStr = ('00' + minStr).substring(minStr.length);
    return hrs + ':' + minStr + ':' + secStr;
  } else {
    return min + ':' + secStr;
  }
};

function getBrowser() {
  // Browser checks based on https://github.com/mbasso/react-browser-detection.
  var isGoogleBot = navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1; // eslint-disable-next-line

  var isIE =
  /*@cc_on!@*/
  false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isOpera = !!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isChrome = !isGoogleBot && !isEdge && !isOpera && !!window.chrome && (!!window.chrome.webstore || navigator.vendor.toLowerCase().indexOf('google inc.') !== -1);
  var isSafari = !isChrome && navigator.userAgent.toLowerCase().indexOf('safari') !== -1;
  return {
    isGoogleBot: isGoogleBot,
    isIE: isIE,
    isEdge: isEdge,
    isOpera: isOpera,
    isChrome: isChrome,
    isSafari: isSafari
  };
}

function stripTags(stringWithTags) {
  return stringWithTags.replace(/<[^>]+>/g, '');
}

function getOptimizedCloudinaryUrl(imgSrc, transformations) {
  var overrideWidthHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var src = imgSrc ? imgSrc.trim() : imgSrc; // Skip if this is not on cloudinary, is an svg,
  // Or already has q_auto, w_ or h_ attributes.

  if (!src || !/\/assets-proxy\//i.test(src) || src.indexOf('fl_sanitize') > -1 || src.indexOf('q_auto') > -1 || !overrideWidthHeight && src.match(/w_[0-9]{1,5}/) || !overrideWidthHeight && src.match(/h_[0-9]{1,5}/)) {
    return src;
  }

  var params = ['q_auto'];

  if (transformations && transformations.width) {
    params.push("w_".concat(transformations.width));
  }

  if (transformations && transformations.height) {
    params.push("h_".concat(transformations.height));
  }

  var paramString = params.join();
  var url = src.replace(/(image|video)\/upload(.*\/?)(\/v[0-9]{10})/, "$1/upload/".concat(paramString, "$3")); // Recipe image.

  url = url.replace(/image\/upload\/(t_WINE_LARGE|t_WINE_EXTRALARGE)\//, "image/upload/".concat(paramString, "/"));
  var queryParam = src.indexOf('?') > 0 ? src.substring(src.indexOf('?')) : '';

  if (queryParam) {
    url = url.replace(queryParam, '');
  }

  var isVideo = src.indexOf('/video/upload') > -1;
  return isVideo ? url : "".concat(url, "?auto=webp");
}

var Utility = {
  dangerousHTML: dangerousHTML,
  distance: distance,
  resetUID: resetUID,
  generateUID: generateUID,
  getBrowser: getBrowser,
  getLinkTitleText: getLinkTitleText,
  getOptimizedCloudinaryUrl: getOptimizedCloudinaryUrl,
  nodeIsChildOf: nodeIsChildOf,
  formatCustomAttribute: formatCustomAttribute,
  makeCancelable: makeCancelable,
  replaceTokens: replaceTokens,
  parseInterpolationParams: parseInterpolationParams,
  getDurationFromMs: getDurationFromMs,
  stripTags: stripTags
};
export default Utility;